/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiimagetitle2Inputs */

const en_aiimagetitle2 = /** @type {(inputs: Aiimagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate an image`)
};

const de_aiimagetitle2 = /** @type {(inputs: Aiimagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild generieren`)
};

/**
* | output |
* | --- |
* | "Generate an image" |
*
* @param {Aiimagetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiimagetitle2 = /** @type {((inputs?: Aiimagetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiimagetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiimagetitle2(inputs)
	return de_aiimagetitle2(inputs)
});
export { aiimagetitle2 as "aiImageTitle" }